import React from 'react';
import {
  WidgetComponents,
  widgetRenderer,
  widgetPreset,
} from './WidgetRegistry';

/**
 * Draws a region with the widget it declares.
 *
 * The one place a widget name becomes a component, so a container renders its children without
 * knowing what they are.
 *
 * A widget may be a preset of another - a practice panel is a field grid reading the customer's
 * products - in which case the preset's own properties stand behind the region's. The region wins,
 * so a preset is a starting point rather than a constraint.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.region - The compiled region.
 *
 * @returns {React.JSX.Element}
 */
const RegionWidget = function RegionWidget({ region }) {
  const Widget = WidgetComponents[widgetRenderer(region?.widget)];

  if (!Widget) {
    console.warn(`Unsupported widget: ${region?.widget}`);
    return null;
  }

  const preset = widgetPreset(region?.widget);

  return <Widget region={preset ? { ...preset, ...region } : region} />;
};

export default RegionWidget;
